var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.drawer,
        direction: "rtl",
        width: "400px",
        "modal-append-to-body": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _vm.form
        ? _c("BjDivider", [
            _vm._v(_vm._s(_vm.form.id ? "编辑仓库" : "新建仓库")),
          ])
        : _vm._e(),
      _vm.drawer
        ? _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                inline: "",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "仓库名称：", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: 20,
                      placeholder: _vm.$t("inputText"),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "仓库编码：", prop: "id" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "自动生成",
                      clearable: "",
                      disabled: "",
                    },
                    model: {
                      value: _vm.form.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "id", $$v)
                      },
                      expression: "form.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "仓库类型：", prop: "typeCode" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          _vm.STOCK_WAREHOUSE_TYPE_SON_2_LIST.bjGet(
                            _vm.form.typeCode
                          )
                        )
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "foot" },
        [
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onComfirm } },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }